import * as React from 'react';
import { FlooringLayoutProps } from './FlooringLayoutAssets';
export const LameVertical = ({ props }: { props: FlooringLayoutProps }) => {
    const { fillColor = '#13123A', svgProps } = props;
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
            <path d="M2.398 45.6V2.4h43.2v43.2z" fill="#fff" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 48V0h48v48zm2.4-2.4h43.2V2.4H2.4z" fill="#13123A" />
            <path
                d="M10.1 45.6H7.7V2.4h2.4zm7.649 0h-2.4V2.4h2.4zm7.65 0H23V2.4h2.4zm7.65 0h-2.4V2.4h2.4zm7.65 0h-2.4V2.4h2.4z"
                fill={fillColor}
            />
        </svg>
    );
};
